import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import DateSelectionModal from '../../components/Reservation/DateSelectionModal';
import RoomSelectionModal from '../../components/Reservation/RoomSelectionModal';
import SummaryModal from '../../components/Reservation/SummaryModal';
import Modal from '../../components/Facilities/Modal';
import { t } from "@lingui/macro";

const Reservations = () => {
  const [step, setStep] = useState(1);
  const [reservationData, setReservationData] = useState({
    startDate: null,
    endDate: null,
    availableRooms: [],
    roomSelections: {},
    totalPrice: 0,
    guestCount: 1,
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);  

  const handleDatesSelected = async (startDate, endDate) => {
    setReservationData((prev) => ({ ...prev, startDate, endDate }));
    const startDateStr = startDate.toISOString().split('T')[0];
    const endDateStr = endDate.toISOString().split('T')[0];

    try {
      const response = await API.get('/api/rooms/public/available', {
        params: { startDate: startDateStr, endDate: endDateStr },
      });
      if (Array.isArray(response.data)) {
        setReservationData((prev) => ({ ...prev, availableRooms: response.data }));
        setStep(2);
      } else {
        console.error('Expected an array but got:', response.data);
        alert(t`Error: Unexpected data format from the server.`);
      }
    } catch (error) {
      console.error('Error fetching available rooms: ', error);
      alert(t`Error fetching available rooms. Please try again.`);
    }
  };

  const handleRoomSelection = (roomSelections, totalPrice, guestCount) => {
    setReservationData((prev) => ({
      ...prev,
      roomSelections,
      totalPrice,
      guestCount,
    }));
    setStep(3);
  };

  const handleReservationSuccess = () => {
    setShowSuccessModal(true);
    setStep(1);  
    setReservationData({
      startDate: null,
      endDate: null,
      availableRooms: [],
      roomSelections: {},
      totalPrice: 0,
      guestCount: 1,
    });
  };

  useEffect(() => {
    console.log("Updated reservationData state:", reservationData);
  }, [reservationData]);

  return (
    <div>
      {step === 1 && (
        <DateSelectionModal
          onDatesSelected={handleDatesSelected}
          onClose={() => console.log('Modal closed')}
        />
      )}

      {step === 2 && (
        <RoomSelectionModal
          availableRooms={reservationData.availableRooms}
          startDate={reservationData.startDate}
          endDate={reservationData.endDate}
          onRoomSelection={handleRoomSelection}
          onBack={() => setStep(1)}
        />
      )}

      {step === 3 && reservationData && (
        <SummaryModal
          reservationData={reservationData}
          onBack={() => setStep(2)}
          onSuccess={handleReservationSuccess}
        />
      )}

      {showSuccessModal && (
        <Modal
          message={t`Reservation completed successfully!`}
          onClose={() => setShowSuccessModal(false)}
          isSuccess={true}
        />
      )}
    </div>
  );
};

export default Reservations;
